import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { FsPolicy } from './policy';

export class FsPolicyGroup extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => FsPolicy)
  public policies: FsPolicy[];

  @Expose()
  public isSystemManaged: boolean;

  @Expose()
  public isOrganizationManaged: boolean;

  @Expose()
  public isEditable: boolean;

  @Expose()
  public permissions: any[];

  @Expose()
  public name: string;

  @Expose()
  public description: string;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public disabled: boolean;

  @Expose()
  public canEdit: boolean;

  @Expose()
  public canView: boolean;

  @Expose()
  public isAdmin: boolean;

  @Expose()
  public isExternallyManaged: boolean;

  @Expose()
  public externalRef: string;

  @Expose()
  public canEditPermissions: boolean;

  @Expose()
  public canEditMembers: boolean;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);

    // To be backwards compatible, if canEditPermissions are undefined then respect old
    // isExternallyManaged logic
    if (this.canEditPermissions === undefined) {
      this.canEditPermissions = this.isExternallyManaged ? false : this.canEdit;
    }
    if (this.canEditMembers === undefined) {
      this.canEditMembers = this.isExternallyManaged ? false : this.canEdit;
    }
  }

  get displayName(): string {
    let newName = this.name;
    if (this.isSystemManaged && this.name.substring(0, 6).toLowerCase() === 'fusus ') {
      newName = this.name.substring(6);
    }
    if (newName === 'Restricted Location and Camera Viewer') {
      newName = 'Location and Camera Viewer - Restricted';
    }
    return newName.replace('Alarm', 'Alert').replace('Video Room', 'Live Link');
  }
}
